import { useIntl } from 'react-intl';
import { IconFolder } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';

type Props = {
  description: string;
};

export const NoWorkspacesPlaceholder = ({ description }: Props) => {
  const intl = useIntl();
  return (
    <Stack flex={1}>
      <Stack alignItems="center" spacing={1} my="auto">
        <SvgIcon fontSize="large">
          <IconFolder />
        </SvgIcon>
        <Typography variant="h6">
          {intl.formatMessage({
            id: 'containers.settings.queues.noWorkspaces.title',
          })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
};
